import { SvgIcon } from '../../../components'
import * as React from 'react'
import { useTheme } from '../../../hooks/useTheme'

function Reply(props, ref) {
  const theme = useTheme()

  return (
    <SvgIcon
      className='reply-icon'
      viewBox='0 0 16 16'
      {...props}
      ref={ref}
      sx={{
        fontSize: '1rem',
        height: '1rem',
        width: '1rem',
        fill:
          props?.variant === 'contained' ? '#FFF' : theme.palette.primary.main,
        ...props.sx
      }}
    >
      <path d='M5.921 11.9 1.353 8.62a.72.72 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z' />
    </SvgIcon>
  )
}

const MemoReply = React.memo(React.forwardRef(Reply))

export default MemoReply
